import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from 'react-redux';
import reportWebVitals from "./reportWebVitals";
import SiteRoutes from './routes';
import store from './redux/store/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/style.css";
import "./assets/css/media.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <SiteRoutes />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
